import React from 'react';
import {Box} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Grid from "@mui/material/Grid";
import {useNavigate} from "react-router-dom";
const BottomNav = (props) => {
  const {hasBack, rightButton, leftButton} = props
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };

  return (<>
      <Box className="bottom-nav-padding"></Box>
      <Grid container className="bottom-nav">
        <Grid item xs={6}>
          {hasBack && (
            <IconButton
              className="bottom-nav-text-icon"
              onClick={handleBack}
            >
              <ArrowBackIcon />
            </IconButton>
          )}
          {leftButton}
        </Grid>
        <Grid item xs={6}>
          {rightButton}
        </Grid>
      </Grid>
  </>

);
};

export default BottomNav;
